import * as types from './types';

export function setIsMenuOpen(payload) {
  return {
    type: types.SET_IS_MENU_OPEN,
    payload: payload,
  };
}
